import React from 'react';
import { Redirect, useLocation } from 'react-router-dom';
import { canAccessPath, defaultHomePath } from '../lib/access';

/**
 * Blocks non-admins from admin console URLs.
 * Must sit inside AdminGuard (authenticated).
 */
export default function RoleGate({ children }) {
  const location = useLocation();
  if (!canAccessPath(location.pathname)) {
    return <Redirect to={defaultHomePath()} />;
  }
  return <>{children}</>;
}
